module.exports = __webpack_public_path__ + "static/media/minus.af202588.svg";